import pino from 'pino';
import { env } from './env';

export type LogLevel = 'trace' | 'debug' | 'info' | 'warn' | 'error' | 'fatal';

interface LogContext {
  [key: string]: unknown;
}

// Pino's browser build drops msg when the context argument is undefined, so every call passes an object
const createLogger = () => {
  const logger = pino({
    level: env.isDev ? 'debug' : 'info',
    enabled: env.enableLogging,
    browser: {
      asObject: true,
      serialize: true,
    },
  });

  return {
    trace: (msg: string, context?: LogContext) => logger.trace(context ?? {}, msg),
    debug: (msg: string, context?: LogContext) => logger.debug(context ?? {}, msg),
    info: (msg: string, context?: LogContext) => logger.info(context ?? {}, msg),
    warn: (msg: string, context?: LogContext) => logger.warn(context ?? {}, msg),
    error: (msg: string, context?: LogContext) => logger.error(context ?? {}, msg),
    fatal: (msg: string, context?: LogContext) => logger.fatal(context ?? {}, msg),
    child: (bindings: LogContext) => {
      const childLogger = logger.child(bindings);
      return {
        trace: (msg: string, context?: LogContext) =>
          childLogger.trace(context ?? {}, msg),
        debug: (msg: string, context?: LogContext) =>
          childLogger.debug(context ?? {}, msg),
        info: (msg: string, context?: LogContext) =>
          childLogger.info(context ?? {}, msg),
        warn: (msg: string, context?: LogContext) =>
          childLogger.warn(context ?? {}, msg),
        error: (msg: string, context?: LogContext) =>
          childLogger.error(context ?? {}, msg),
        fatal: (msg: string, context?: LogContext) =>
          childLogger.fatal(context ?? {}, msg),
      };
    },
  };
};

export const logger = createLogger();

export const useLogger = (component: string) => {
  return logger.child({ component });
};
